import React from "react"
import { createStyles, forwardRef, View } from "@design-system/core"
import { useTabsContext } from "./TabsContext"
import { TabPanelProps } from "./types"

export const TabPanel = forwardRef<TabPanelProps, "div">(
  (props, forwardedRef) => {
    const { isLazy } = useTabsContext()
    const { children, isSelected, id, style, ...others } = props

    return (
      <View
        tabIndex={0}
        {...others}
        accessibilityRole="tabpanel"
        nativeID={id}
        ref={forwardedRef}
        style={[styles.root, !isSelected && styles.hidden, style]}
      >
        {!isLazy || isSelected ? children : null}
      </View>
    )
  },
)

const styles = createStyles((theme) => ({
  root: {
    padding: theme.spaces.spacing16,
    outlineWidth: 0,
  },
  hidden: {
    display: "none",
  },
}))
